module.exports = __webpack_public_path__ + "static/media/docker.6eff29a8.svg";